import "antd/es/input/style";
import _Input from "antd/es/input";
var _excluded = ["className", "disabled", "onBlur", "onFocus", "onChange", "onSearch", "withSuffixIcon", "enterButton", "loading", "suffix"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useState, useRef, useMemo } from 'react';
import { composeRef } from 'rc-util/lib/ref';
import { useBrandContext } from '@osui/brand-provider';
import Button from '@osui/button';
import { IconSearchOutlined } from '@osui/icons';
import classNames from 'classnames';
import './index.less';
var clsPrefix = 'osui-input';
var Search = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var className = props.className,
      disabled = props.disabled,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      onChange = props.onChange,
      onSearch = props.onSearch,
      withSuffixIcon = props.withSuffixIcon,
      enterButton = props.enterButton,
      loading = props.loading,
      suffix = props.suffix,
      inputProps = _objectWithoutProperties(props, _excluded);

  var inputRef = useRef(null);

  var _useBrandContext = useBrandContext(),
      brand = _useBrandContext.brand;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var innerClassNames = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-focused"), focused), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _classNames), className);
  var innerWithSuffixIcon = withSuffixIcon !== null && withSuffixIcon !== void 0 ? withSuffixIcon : brand === 'icloud';
  var handleFocus = useCallback(function (e) {
    onFocus && onFocus(e);
    setFocused(true);
  }, [onFocus]);
  var handleBlur = useCallback(function (e) {
    onBlur && onBlur(e);
    setFocused(false);
  }, [onBlur]);
  var handleSearch = useCallback(function (e) {
    onSearch && onSearch(inputRef.current.input.value, e);
  }, [onSearch]);
  var handleClick = useCallback(function (e) {
    handleSearch(e);
  }, [handleSearch]);
  var handleChange = useCallback(function (e) {
    // 点击清除时也要调用onSearch
    if (e && e.target && e.type === 'click' && onSearch) {
      onSearch(e.target.value, e);
    }

    if (onChange) {
      onChange(e);
    }
  }, [onSearch, onChange]); // 处理搜索图标，如果没有传入的话，默认是搜索icon。TODO： loading的支持

  var innerSuffix = useMemo(function () {
    var icon = suffix;

    if (innerWithSuffixIcon && typeof icon === 'undefined') {
      icon = /*#__PURE__*/React.createElement(IconSearchOutlined, null);
    }

    if ( /*#__PURE__*/React.isValidElement(icon)) {
      return /*#__PURE__*/React.cloneElement(icon, {
        className: "".concat(clsPrefix, "-search-icon"),
        onClick: handleClick
      });
    }

    return icon;
  }, [suffix, innerWithSuffixIcon, handleClick]);
  var innerEnterButton = useMemo(function () {
    if (typeof enterButton === 'string') {
      return /*#__PURE__*/React.createElement(Button, {
        loading: loading,
        disabled: disabled,
        type: "primary"
      }, enterButton);
    }

    return enterButton;
  }, [enterButton, loading, disabled]);

  if (innerWithSuffixIcon && !enterButton) {
    return /*#__PURE__*/React.createElement(_Input, _objectSpread(_objectSpread({
      ref: composeRef(inputRef, ref)
    }, inputProps), {}, {
      className: classNames(clsPrefix, innerClassNames),
      disabled: disabled,
      suffix: innerSuffix,
      onPressEnter: handleSearch,
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur
    }));
  }

  return /*#__PURE__*/React.createElement(_Input.Search, _objectSpread(_objectSpread({
    ref: composeRef(inputRef, ref)
  }, props), {}, {
    className: classNames(clsPrefix, innerClassNames),
    disabled: disabled,
    onFocus: handleFocus,
    onBlur: handleBlur,
    enterButton: innerEnterButton,
    loading: loading
  }));
});
export default Search;
//# sourceMappingURL=Search.js.map